module.exports = "/images/bb.svg?d53d08bfc52bc67bd22afe69550939f3";